'use client';

import { notifySaveSuccess, notifySave, notifyDelete, notifyError } from '@/lib/library/notifications';

export function showSavedToast(title: string) {
  notifySaveSuccess(title);
}

export function showSavedToastWithUndo(title: string, onUndo: () => void) {
  notifySave(title, onUndo);
}

export function showDeletedToast(title: string, onUndo: () => void) {
  notifyDelete(title, onUndo);
}

export function showErrorToast(title: string, description?: string) {
  notifyError(title, description);
}

export function showGroupUpdatedToast(title: string, onUndo: () => void) {
  notifySave(title, onUndo);
}

export function showRemovedFromGroupToast(title: string, onUndo: () => void) {
  notifyDelete(title, onUndo);
}

export function showNoteSavedToast(title: string) {
  notifySaveSuccess(title);
}
